<template lang="pug">
  v-snackbar.snackbar(
    v-model="showSnackbar"
    top
    right
    :timeout="timeout"
    :color="getColor"
    :multi-line="$vuetify.breakpoint.smAndDown"
  ) {{ snackbar.message }}
    template(v-slot:action="{ attrs }")
      v-btn(color="white" small text v-bind="attrs" @click="close") x
</template>

<script>
export default {
  name: 'snackbar',
  props: ['value', 'snackbar'],
  data: () => ({
    timeout: 6000,
  }),
  computed: {
    showSnackbar: {
      get() {
        return this.value || false;
      },
      set(value) {
        this.$emit('input', value);
        this.$emit(value ? 'open' : 'close');
      }
    },
    getColor() {
      const option = {
        success: '#1D6D2A',
        error: '#EC3636',
        alert: '#E2BF31',
        info: '#214EF1',
      };
      return option[this.snackbar.type];
    }
  },
  methods: {
    close() {
      this.showSnackbar = false;
    }
  },
}
</script>

<style lang="sass" scoped>

</style>